<template>
  <order-list :is-order-status="-1"></order-list>
</template>

<script>
import OrderList from './components/OrderList'
export default {
  name: 'All',
  components: {
    OrderList
  }
}
</script>
